
var ssi_rules = {
	"Plan": {		
		"load": {
			"resolve": function(params) { if (params.plan == undefined) return "Plan_load.json"; else return "Plan_load_" + params.plan + ".json";},
		},						
		"getPlans": {
			"resolve": function(params) { return "Plan_getPlans.json"; },
		},
		"landmarks": {
			"resolve": function(params) { return "Plan_landmarks_" + params.plan + ".json"; },
		},
		"connections": {
			"resolve": function(params) { return "Plan_connections_" + params.plan + ".json"; },
		},
		"plantoid": {
			"resolve": function(params) {return "Plan_routes.json"},
			"process": function(params, data) {
				return {"data": data.data.places[params.planspot]};
			}
		},
		"route": {
			"resolve": function(params) {return "Plan_routes.json"},
			
			"process": function(params, data) {
				
					try {
						var d = new Dijkstras();
						d.setGraph(data.data.graph);

						var path = d.getPath(params.from.toString(), params.target.toString());

						var places = [];

						if (path.length > 0) {
							path.unshift(params.from);
							for(var n in path) {
								places.push(data.data.places[path[n]]);
							}
						}
					} catch(e) {
					//	alert(e);
					}
					//alert(places);

					return {"data" : {"path" : path, "places": places}};

			}			
		}

	},

	"Search": {
		"results": {
			"resolve": function(params) {return "Search_all.json"},
			"process": function(params, data) { 
				var result = [];

				try {
				for(var i = 0; i < data.data.length; i ++) {
					var row = data.data[i];
					if (row['title'].toUpperCase().substr(0, params.words.length) == params.words.toUpperCase()  ||
						(row['id'] == params.words.toUpperCase()) ||
						(row['psc_name'] != null && row['psc_name'].toUpperCase().substr(0, params.words.length) == params.words.toUpperCase()) ||
						(row['loc_name'] != null && row['loc_name'].toUpperCase().substr(0, params.words.length) == params.words.toUpperCase())) {
						result.push(row);
					}
				}
				} catch(e) {
					alert("Row: " + i + "; " + e);
				}
				//alert("Found: " + result.length);

				return {"data": result};
			 }
		}
	}

}

function callssi(endpoint, className, method, params, fun, local) {
	var request = {};
					
	request.className = className;
	request.methodName = method;
					
	for(var propertyName in params) {
		request["parameters!" + propertyName] = params[propertyName];
	}

	if (local) {
		/*
		var lf = new LocalFile(endpoint);
		lf.load(function(data) {
			alert(data);
			fun(JSON.parse(data));
		});
		*/
		$.ajax({						
			type: "GET",
			url: endpoint,
			dataType: "json",

		}).done(function( resp ) {
			if (ssi_rules[className][method]['process'] != undefined) resp = ssi_rules[className][method]['process'](params, resp);
			fun(resp);
		});

	} else {		
		$.ajax({
			type: "POST",
			url: endpoint,
			dataType: "json",
			data: request
		}).done(function( resp ) {
			fun(resp);
		});
	}
}

function ssi(className, method, params, fun) {
	try {

		if (!player.offline || ssi_rules[className] == undefined || ssi_rules[className][method] == undefined || ssi_rules[className][method]['resolve'] == undefined) {

			if (player.offline)
				callssi("http://www.wkraj.pl/gatewayManager.php?result=json", className, method, params, fun, false);
			else
				callssi("/gatewayManager.php?result=json", className, method, params, fun, false);

		} else {
			var fn = "data/" + ssi_rules[className][method]['resolve'](params);

			callssi(fn, className, method, params, fun, true);
			/*
			Storage.resource(fn, function(found, url) {
				var furl;				
				var local = false;

				if (found) {
					//alert(fn);
					local = true;
					furl = url;
				} else {
					furl = "http://www.wkraj.pl/gatewayManager.php?result=json";
				}

				callssi(furl, className, method, params, fun, local);
			});
			*/
		}

	} catch(e) {
		console.log(e);
		//alert("!!!" + e);
	}
};
